import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../../services/authService';

const AuthorizeRoute = ({ element }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Check if user exists in localStorage
        const user = authService.getCurrentUser();
        if (!user) {
          setIsAuthenticated(false);
          setChecking(false);
          return;
        }

        // If using cookies, verify token is still valid by calling getUserInfo
        // getUserInfo will wait for middleware refresh if needed (up to 3.5 seconds)
        if (authService.useCookies) {
          try {
            await authService.getUserInfo();
            setIsAuthenticated(true);
          } catch (error) {
            // If getUserInfo fails after retries (401), user is not authenticated
            // But don't immediately redirect - let the error propagate so user sees what happened
            setIsAuthenticated(false);
          }
        } else {
          // For localStorage, check token exists
          const token = authService.getToken();
          setIsAuthenticated(!!token);
        }
      } catch (error) {
        setIsAuthenticated(false);
      } finally {
        setChecking(false);
      }
    };

    checkAuth();
  }, []);

  if (checking) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    // Redirect to login page with return url
    return <Navigate to="/login" replace />;
  }

  return element;
};

export default AuthorizeRoute; 